import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';
import { channelActions, channelSelectors } from 'redux/channel';

const ChannelLoader = () => {
  const dispatch = useDispatch();

  const { values: { channelId } } = useFormState({ subscription: { values: true } });

  const channelSelector = useSelector(channelSelectors.getChannelSelector);

  useEffect(() => {
    const channel = channelSelector(channelId);

    if (channelId && !channel?.permissions) {
      dispatch(channelActions.getChannel({ channelId }));
    }
  }, [channelId, channelSelector, dispatch]);

  return null;
};

export default ChannelLoader;
